(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/info-pair.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/info-pair.js');
'use strict';

const InfoPair = _ref => {
  let {
    title,
    info
  } = _ref;
  return React.createElement("div", null, React.createElement("span", {
    className: "f-bold"
  }, title, ":", ' '), React.createElement("span", null, info));
};
svs.myProfile.react.pages.myInformation.myInformation.components.InfoPair = InfoPair;

 })(window);